import { createFileRoute } from "@tanstack/react-router";

import { YearsIndexPage, yearsIndexHead } from "../components/prenoms/year-pages";
import { namesApi } from "../lib/api";
import { seo } from "../lib/head";

export const Route = createFileRoute("/prenoms/annee/")({
  staticData: { ssr: true },
  loader: ({ context }) =>
    context.queryClient.query({
      queryKey: ["prenoms-years"],
      queryFn: namesApi.years,
      staleTime: "static",
    }),
  head: () => seo(yearsIndexHead()),
  component: Page,
});
function Page() {
  return <YearsIndexPage years={Route.useLoaderData()} />;
}
